import { defineComponent, h } from "vue";
import { simplyResolveComponent } from "../lib/simplyResolveComponent.js";
const defaultWrapper = "div";
const PrismicEmbedImpl = /* @__PURE__ */ defineComponent({
  name: "PrismicEmbed",
  props: {
    field: {
      type: Object,
      required: true
    },
    wrapper: {
      type: [String, Object, Function],
      default: void 0,
      required: false
    }
  },
  setup(props) {
    if (!props.field) {
      return () => null;
    }
    return () => {
      return h(simplyResolveComponent(props.wrapper || defaultWrapper), {
        "data-oembed": props.field.embed_url,
        "data-oembed-type": props.field.type,
        "data-oembed-provider": props.field.provider_name,
        innerHTML: props.field.html || null
      });
    };
  }
});
const PrismicEmbed = PrismicEmbedImpl;
export {
  PrismicEmbed,
  PrismicEmbedImpl
};
//# sourceMappingURL=PrismicEmbed.js.map
